import { useSyncExternalStore } from "react";

/**
 * Tailwind's `lg` breakpoint (`min-width: 1024px`), for the places where a
 * component must know in script what a `lg:` class decides in CSS — e.g. whether
 * a column is a scroll box right now.
 */
export const LG_MEDIA_QUERY = "(min-width: 1024px)";

/**
 * Whether `query` matches, kept current as the viewport changes. `false` where
 * `matchMedia` does not exist (server rendering, a bare test environment).
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window === "undefined" || !window.matchMedia) return () => undefined;
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    () =>
      typeof window !== "undefined" && window.matchMedia ? window.matchMedia(query).matches : false,
    () => false,
  );
}
